export const items = [
    [
        'Lorem ipsum...',
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
        '/images/redactor/clips-lorem-ipsum.png',
    ],
    ['Red label', '<b class="label-red">Label</b>', '/images/redactor/clips-red-label.png'],
];
